import { useQuery } from '@tanstack/react-query'
import { getStates, getMappedFields } from '../api'

/**
 * Hook to fetch states list
 * @returns {object} Query result with states data, loading state, etc.
 */
export const useStates = () => {
	return useQuery({
		queryKey: ['states'],
		queryFn: () => getStates(),
		staleTime: Infinity, // States rarely change, cache indefinitely
		select: (data) => [
			{
				state_code: "",
				state_desc: "",
				ctry_code: ""
			},
			...data
		],
	})
}

/**
 * Hook to fetch mapped fields (types and address types)
 * @returns {object} Query result with mapped fields data, loading state, etc.
 */
export const useMappedFields = () => {
	const defaultMappedTypes = [
		{
			id: 0,
			value: null,
			name: "No Type ID",
			reference: ''
		}
	]

	const defaultAddressTypes = [
		{
			id: 0,
			value: null,
			name: "Customer",
			reference: ''
		},
		{
			id: 1,
			value: 2,
			name: "Job Location",
			reference: ''
		}
	]

	return useQuery({
		queryKey: ['mappedFields'],
		queryFn: () => getMappedFields(),
		staleTime: Infinity, // Mapped fields rarely change, cache indefinitely
		select: (data) => ({
			mapped_types: [
				...defaultMappedTypes,
				...(data.mapped_types || [])
			],
			address_types: [
				...defaultAddressTypes,
				...(data.address_types || [])
			]
		}),
	})
}

